import React, { useContext } from "react";
import { AppContext } from "../../../../context/AppContext";
import CashierModal from "../../../Modals/CashierModals/CashierModal";
import SearchModal from "../../../Modals/SearchModal/SearchModal";
import AccountButton from "../AccountButton/AccountButton";
import { StyledMobileNavBar } from "./styles";
import { useAuth } from "@/context/AuthContext";

const HamburgerIcon = () => (
  <svg height="20" viewBox="0 0 512 512" width="20">
    <path d="m464.883 64.267h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z" />
    <path d="m464.883 208.867h-417.766c-25.98 0-47.117 21.136-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.013-21.137-47.149-47.117-47.149z" />
    <path d="m464.883 353.467h-417.766c-25.98 0-47.117 21.137-47.117 47.149 0 25.98 21.137 47.117 47.117 47.117h417.766c25.98 0 47.117-21.137 47.117-47.117 0-26.012-21.137-47.149-47.117-47.149z" />
  </svg>
);

const MobileNavBar = () => {
  const { updateSidebar } = useContext(AppContext);
  const { user } = useAuth();

  return (
    <StyledMobileNavBar>
      <div className="buttons-container">
        {user?.profile && (
          <>
            <AccountButton />
            <CashierModal button="Get Coins" />
          </>
        )}

        <SearchModal />

        <button className="button" onClick={() => updateSidebar((prev) => !prev)}>
          <HamburgerIcon />
        </button>
      </div>
    </StyledMobileNavBar>
  );
};

export default MobileNavBar;
